<app-larged-tuile
  icon="fa-kit fa-picto-injection-cl"
  [title]="'P0003605.dashboard.injectionCL' | translate"
  [buttons]="buttonMode"
  [status]="
    buttons[this.actionStack!.getValue('icSEtatPompe')].title! | translate
  "
  [statusMode]="
    this.actionStack!.getValue('icSAlarme') === 1
      ? 'alarm'
      : buttons[this.actionStack!.getValue('icSEtatPompe')].status!
  "
  [selectItem]="this.actionStack!.getValue('icCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.InjectionChlore_Controle,
      'icCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
